import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core'

@Component({
  selector: 'content-loading',
  templateUrl: './content-loading.component.html',
  styleUrls: ['./content-loading.component.css'],
})
export class ContentLoadingComponent implements OnInit {
  public options: any = {
    path: '/assets/loader.json',
  }

  constructor() {}

  ngOnInit() {}
}
